const firebaseConfig = {
    apiKey: "AIzaSyDBt85E-NL14PUIVU3xPVAHt2y-UUsqJqM",
    authDomain: "bd-healthcare.firebaseapp.com",
    projectId: "bd-healthcare",
    storageBucket: "bd-healthcare.appspot.com",
    messagingSenderId: "1044096672529",
    appId: "1:1044096672529:web:6e2e559ad22727182d62b0"
};

export default firebaseConfig;